import { el } from "./dom";
import type { TabId } from "../main";

export function renderSecurityPanel(onNavigate: (tab: TabId) => void): HTMLElement {
  const serviceApiLink = el("button", { type: "button", class: "link-btn" }, ["Service API"]);
  serviceApiLink.addEventListener("click", () => onNavigate("service-api"));
  const integrationLink = el("button", { type: "button", class: "link-btn" }, ["Integration guide"]);
  integrationLink.addEventListener("click", () => onNavigate("integration"));

  return el("section", {}, [
    el("p", { class: "eyebrow" }, ["System · Security"]),
    el("h2", {}, ["What we see, and what we don't"]),
    el("p", { class: "lede" }, [
      "Every seal and every unlock happens on this device. Read this before you trust it with something that matters.",
    ]),
    el("div", { class: "card prose" }, [
      el("p", {}, [
        "All encryption, decryption, and key derivation run locally, inside a dedicated Web Worker, using ",
        el("code", {}, ["libsodium.js"]),
        " - the same audited library family the command-line tool uses. The server this app talks to never receives plaintext, a password, or a private key: only ciphertext and public keys ever leave your browser.",
      ]),
      el("p", { class: "warning" }, [
        "A browser tab can't promise what an installed program can. This page's code can change on every visit - a server operator could serve different JavaScript to you than to anyone else, and there's no local copy left behind for you to check afterward the way there is with a downloaded binary. We narrow that gap with a strict content security policy, zero third-party scripts, a small and auditable dependency list, and a build you can reproduce and hash-check yourself - but if you don't trust whoever is serving this page to keep serving that exact, audited build, use the command-line tool instead for anything that really matters.",
      ]),
      el("p", {}, [
        "This app authenticates to the relay with a self-service API token - request one with no sign-in at all (see the right rail, or the Service API page). The command-line tool authenticates differently - a permanent, admin-issued API key (",
        el("code", {}, ["python -m cli.main create-api-key"]),
        ") - since it's meant for scripting and automation rather than a short-lived browser token. See the ",
        integrationLink,
        " page for both paths.",
      ]),
      el("p", {}, [
        "For the full HTTP endpoint reference and a live try-it, see the ",
        serviceApiLink,
        " page.",
      ]),
    ]),
  ]);
}
